<template>
  <div class="inputCounter"
    :class="{ 'error': errorInput }"
    ref="input">
    <div class="inputCounter__block">
        <div class="inputCounter__name">
            <div class="inputCounter__title">{{ label }}</div>
            <div class="inputCounter__age">{{ age }}</div>
        </div>
        <div class="inputCounter__counter">
            <!-- Minus -->
            <div class="inputCounter__count" @mousedown.prevent="minus">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.66699 7.99998C2.66699 7.63179 2.96547 7.33331 3.33366 7.33331H12.667C13.0352 7.33331 13.3337 7.63179 13.3337 7.99998C13.3337 8.36817 13.0352 8.66665 12.667 8.66665H3.33366C2.96547 8.66665 2.66699 8.36817 2.66699 7.99998Z" fill="#526C82" fill-opacity="0.8"/>
                </svg>
            </div>
            <!-- Input -->
            <input
                :value="value"
                :maxlength="maxLength || 10"
                type="text"
                placeholder="0"
                inputmode="decimal"
                name="engines"
                v-mask="'######'"
                class="inputCounter__input"
                @input="onInput"
                ref="input">
            <!-- Plus -->
            <div class="inputCounter__count" @mousedown.prevent="plus">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66699 3.33335C8.66699 2.96516 8.36852 2.66669 8.00033 2.66669C7.63214 2.66669 7.33366 2.96516 7.33366 3.33335V7.33335H3.33366C2.96547 7.33335 2.66699 7.63183 2.66699 8.00002C2.66699 8.36821 2.96547 8.66669 3.33366 8.66669H7.33366V12.6667C7.33366 13.0349 7.63214 13.3334 8.00033 13.3334C8.36852 13.3334 8.66699 13.0349 8.66699 12.6667V8.66669H12.667C13.0352 8.66669 13.3337 8.36821 13.3337 8.00002C13.3337 7.63183 13.0352 7.33335 12.667 7.33335H8.66699V3.33335Z" fill="#526C82" fill-opacity="0.8"/>
                </svg>
            </div>
        </div>
    </div>
    <!-- Error -->
    <BaseInputError :error="errorInput">
      <slot name="empty-input-error" v-if="!value">
        {{ $t('qic_error_empty_input') }}
      </slot>
      <slot class="error" name="invalid-input-error" v-if="value">
        {{ $t('qic_error_invalid_input') }}
      </slot>
    </BaseInputError>
  </div>
</template>

<script>
import BaseInputError from './BaseInputError.vue'
export default {
  props: [
    'value',
    'label',
    'age',
    'validation',
    'maxValue',
    'minValue',
    'maxLength'
  ],
  components: {
    BaseInputError
  },
  computed: {
    errorInput () {
      return this.validation?.$dirty && this.validation?.$invalid
    },
    acceptInput () {
      if (!this.validation) return false
      return !this.validation?.$invalid
    }
  },
  methods: {
    minus () {
      this.$emit('input', +this.value - 1)
    },
    plus () {
      this.$emit('input', +this.value + 1)
    },
    onInput (value) {
      this.$emit('input', value.target.value)
      if (this.validation) {
        this.validation.$reset()
      }
    }
  },
  watch: {
    value () {
      if (this.value <= (this.minValue || 0)) this.$emit('input', this.minValue || 0)
      if (this.maxValue) {
        if (this.value > this.maxValue) this.$emit('input', this.maxValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .rtl .inputCounter__counter {
    direction: ltr;
  }
</style>
